import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import PageTitle from "../../../layouts/PageTitle";
import { formatBookingReference } from "../../../../services/TransferService";

const TransferConfirmation = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const agent = useSelector((state) => state.auth.auth) || {};
	const { bookingId, totalCharge, transferData, searchData, paymentMethod, paymentMessage } = location.state || {};

	if (!bookingId) {
		return (
			<div className="card">
				<div className="card-body text-center py-5">
					<p className="mb-3">No confirmed booking to show.</p>
					<button type="button" className="btn btn-primary" onClick={() => navigate("/dashboard")}>
						Back to Search
					</button>
				</div>
			</div>
		);
	}

	const currency = agent.currency || "AUD";
	const bookingReference = formatBookingReference(bookingId);
	const paidByCard = paymentMethod !== "account";
	const amountPaid = Number(totalCharge || 0);

	return (
		<div className="transfer-flow">
			<PageTitle activeMenu="Confirmation" motherMenu="Dashboard" />
			<div className="row">
				<div className="col-xl-12">
					<div className="alert alert-success text-center">
						{paymentMessage || "Your booking is completed. A confirmation email will be sent shortly."}
					</div>
					<div className="card">
						<div className="card-body">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h5 className="mb-0">Booking Number</h5>
								<h5 className="mb-0 text-primary">#{bookingReference}</h5>
							</div>

							{transferData && (
								<div className="d-flex flex-wrap align-items-center border rounded p-3 mb-3" style={{ gap: "1rem" }}>
									<img src={transferData.vehicle_img} alt="" style={{ width: "120px", objectFit: "contain" }} />
									<div className="flex-grow-1">
										<h5 className="mb-1">
											{transferData.vehicle_type_name} ({transferData.make})
										</h5>
										{searchData && (
											<div className="text-muted">
												{searchData.from?.label} &rarr; {searchData.to?.label}
												<br />
												{searchData.date ? moment(searchData.date).format("DD MMM YYYY") : ""}
												{Number.isInteger(searchData.time?.hour) ? ` at ${String(searchData.time.hour).padStart(2, "0")}:${String(searchData.time.minute).padStart(2, "0")}` : ""}
											</div>
										)}
									</div>
									<h5 className="text-primary mb-0">{currency} {Number(totalCharge || 0).toFixed(2)}</h5>
								</div>
							)}

							<div className="bg-light rounded p-3 text-end">
								<p className="mb-1">Total: {currency} {Number(totalCharge || 0).toFixed(2)}</p>
								<p className="mb-0">Amount Paid: {currency} {amountPaid.toFixed(2)} / {paidByCard ? "Via Card" : "Via Account"}</p>
							</div>

							<div className="text-center mt-4">
								<button type="button" className="btn btn-primary" onClick={() => navigate("/dashboard")}>
									New Search
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TransferConfirmation;
